import { posCheckoutModalStyleDefs } from './posCheckoutModal.styleDefs';
import { posCheckoutLayoutStyleDefs } from './posCheckoutLayout.styleDefs';
import { posCheckoutHeroStyleDefs } from './posCheckoutHero.styleDefs';
import { posCheckoutSummaryStyleDefs } from './posCheckoutSummary.styleDefs';
import { posCheckoutPaymentStyleDefs } from './posCheckoutPayment.styleDefs';
import { posCheckoutDetailStyleDefs } from './posCheckoutDetail.styleDefs';
import { posCheckoutFiscalStyleDefs } from './posCheckoutFiscal.styleDefs';
import { posCheckoutCustomerStyleDefs } from './posCheckoutCustomer.styleDefs';

export const posCheckoutStyleDefs = {
  ...posCheckoutModalStyleDefs,
  ...posCheckoutLayoutStyleDefs,
  ...posCheckoutHeroStyleDefs,
  ...posCheckoutSummaryStyleDefs,
  ...posCheckoutPaymentStyleDefs,
  ...posCheckoutDetailStyleDefs,
  ...posCheckoutFiscalStyleDefs,
  ...posCheckoutCustomerStyleDefs,
} as const;
